import { useSelector } from 'react-redux';
import BotIconUploader from '../../../BotIconUploader';
import classes from './DesignImagesSection.module.css';

const DesignImagesSection = ({
  domainName,
  botName,
  draft,
  setDraft,
  originalImageUrls,
  descriptions,
}) => {
  const { texts } = useSelector(state => state.translate);
  const fields = [
    {
      fieldKey: 'botIconUrl',
      uploadButtonText: texts.uploadBotImage,
      previewFallbackLabel: texts.botImageFallback,
    },
    {
      fieldKey: 'subjectIconUrl',
      uploadButtonText: texts.uploadSubjectImage,
      previewFallbackLabel: texts.subjectImageFallback,
    },
  ];

  return (
    <div className={classes.List}>
      {fields.map(({ fieldKey, uploadButtonText, previewFallbackLabel }) =>
        <BotIconUploader
          key={fieldKey}
          domainName={domainName}
          botName={botName}
          fieldKey={fieldKey}
          iconUrl={draft[fieldKey] ?? ''}
          originalIconUrl={originalImageUrls?.[fieldKey] ?? ''}
          onIconUrlChange={url => setDraft(d => ({ ...d, [fieldKey]: url }))}
          descriptions={descriptions}
          uploadButtonText={uploadButtonText}
          previewFallbackLabel={previewFallbackLabel}
        />
      )}
    </div>
  );
};

export default DesignImagesSection;
